import { BRANCH_EMBLEMS } from "@/lib/constants";
import { Quote } from "lucide-react";

export default function About() {
  return (
    <div className="max-w-4xl mx-auto px-4 py-16">
      <h1 className="font-heading font-black text-4xl sm:text-5xl tracking-tighter text-slate-900">
        Our <span className="text-[#9b111e]">Story</span>
      </h1>

      <div className="card-metal p-8 mt-8 relative" data-testid="about-founder-statement">
        <Quote className="w-10 h-10 text-[#9b111e] mb-4" />
        <p className="text-xl leading-relaxed text-slate-800 font-medium">
          Founded, solely owned and operated by a disabled Special-Operations Air-Force veteran who
          PROUDLY served alongside all 5 branches of the military — and that spirit of teamwork and trust
          drives everything that I do at Care-4U.net. After MIRACULOUSLY surviving a near-death experience which resulted in a post-service
          Traumatic-Brain-Injury, I was left partially paralyzed with limited mobility — and was tired
          of dealing with the laborious and dangerous logistics of transportation.
        </p>
      </div>

      <p className="mt-8 text-lg text-slate-600 leading-relaxed">
        Care-4U.net exists so that the people who need services don't have to fight transportation
        just to get them. Instead, friendly, vetted mobile professionals come to you — for haircuts,
        therapy, lessons, companionship, home services and hundreds more. Every professional is background checked,
        officially certified and promises
        at least four years of experience in their field, to always be polite and wear a smile,
        pledges to drive safe and guarantees to show up and arrive on time wearing a smile during the whole visit!
      </p>

      <div className="mt-14 bg-slate-900 text-white rounded-2xl p-10 text-center">
        <h2 className="font-heading font-black text-3xl">We Support Our Veterans</h2>
        <p className="text-slate-400 mt-3">Honoring all five branches of the U.S. Armed Forces.</p>

        <div className="mt-6 inline-block bg-[#9b111e] text-white rounded-xl px-6 py-4" data-testid="about-veteran-discount">
          <p className="font-heading font-black text-2xl">10% Military Discount ⭐</p>
          <p className="text-red-100 text-sm mt-1">
            Active-duty &amp; veterans save 10% on every booking — with quick verification of your military ID.
          </p>
        </div>

        <div className="mt-8 flex flex-wrap justify-center gap-6 sm:gap-10">
          {BRANCH_EMBLEMS.map((b) => (
            <div key={b.name} className="flex flex-col items-center gap-2" data-testid={`about-branch-${b.name.replace(/\s/g, "-").toLowerCase()}`}>
              <img src={b.url} alt={`U.S. ${b.name} emblem`}
                className="h-24 w-24 sm:h-28 sm:w-28 object-contain rounded-full drop-shadow-[0_6px_14px_rgba(155,17,30,0.5)] transition-transform hover:scale-110" />
              <span className="text-xs font-heading font-black tracking-wide text-slate-300">U.S. {b.name}</span>
            </div>
          ))}
        </div>
      </div>

      <div className="mt-10 card-metal p-6">
        <h3 className="font-heading font-black text-xl text-slate-900">Transparent 5% Platform Fee</h3>
        <p className="text-slate-600 mt-2">
          Every booking includes a clearly displayed 5% platform fee — no hidden costs. That small fee goes
          straight into paying the monthly bill that keeps this website <b>LIVE</b> and running for you. We are
          constantly improving the company with the help of an AI agent, which costs money every month as
          well. Professionals keep the rest and receive real payouts via Stripe.
        </p>
      </div>
    </div>
  );
}
